import React from 'react';
import { useDispatch } from 'react-redux';
import { setInitialProductFlagAction } from 'store/product/slice';
import { AppBundle } from 'api/optimalprint-sdk.d';
import exploreOptions, { ExtendedProductPageSelectorOption } from 'utils/attributes/exploreOptions';
import setBestMatchingProductIdForAttributeOperation from 'store/product/operation/setBestMatchingProductIdForAttributeOperation';
import updateBundledProductOperation from 'store/product/operation/updateBundledProductOperation';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import gtmChangeAttributeEvent from 'utils/gtm/gtmChangeAttributeEvent';
import ProductAttributeColorSelector from './ProductAttributeColorSelector/ProductAttributeColorSelector';
import ProductAttributeSimpleSelector from './ProductAttributeSimpleSelector/ProductAttributeSimpleSelector';
import ProductAttributeDropdownSelectorPremium from './ProductAttributeDropdownSelectorPremium/ProductAttributeDropdownSelectorPremium';

export type ChangeAttributeCallback = (typeName: string, value: string, productId?: number) => void;

export interface ProductAttributeSelectorWithouCallbackProps {
  selector: AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.ProductPageSelector;
  options: ExtendedProductPageSelectorOption[];
  theme?: string;
}

export type ProductAttributeSelectorProps = ProductAttributeSelectorWithouCallbackProps & {
  onClick: ChangeAttributeCallback;
};

const ProductAttributeSelector = ({ selector, options, theme }: ProductAttributeSelectorWithouCallbackProps) => {
  const optionInfo = exploreOptions(options);
  const dispatch = useDispatch();

  const changeAttribute = (typeName: string, value: string, productId?: number) => {
    gtmSendEvent(gtmChangeAttributeEvent(typeName, value));
    dispatch(setInitialProductFlagAction(false));
    dispatch(setBestMatchingProductIdForAttributeOperation(typeName, value, productId || 1));
    dispatch(updateBundledProductOperation());
  };

  if (optionInfo.hasColorOptions) {
    return (
      <ProductAttributeColorSelector theme={theme} selector={selector} options={options} onClick={changeAttribute} />
    );
  }

  // if (optionInfo.hasIconOptions) {
  //   return <ProductAttributeIconSelector selector={selector} options={options} onClick={changeAttribute} />;
  // }

  if (optionInfo.totalOptions > 0) {
    return (
      <ProductAttributeDropdownSelectorPremium
        theme={theme}
        selector={selector}
        options={options}
        onClick={changeAttribute}
      />
    );
  }
  return (
    <ProductAttributeSimpleSelector theme={theme} selector={selector} options={options} onClick={changeAttribute} />
  );
};

export default ProductAttributeSelector;
